export enum CustomerDetailTabs {
    Dashboard = 'Dashboard',
    Profile = 'Profile',
    Internals = 'Internals',
    Payments = 'Payments',
    Billing = 'Billing',
    ActionLog = 'ActionLog',
    Documents = 'Documents',
}
